import {useQuery} from '@tanstack/react-query';

import {ENDPOINTS} from 'constants/endpoints';

import {apiConfig} from 'libs/api/api';
import {flags} from 'libs/rollout';

const ONE_STEP_AVAILABILITY_KEY = 'ONE_STEP_AVAILABILITY_KEY';

type UseOneStepType = {
    selectedShippingMethod: string;
    selectedPaymentMethod: string;
};

/**
 * Makes a request to check one step checkout availability.
 */
export const useIsOneStepAvailable = () => {
    const isExp =
        __BUILD_TYPE__ === 'desktop'
            ? flags.dCheckout1step.isEnabled()
            : flags.mCheckout1step.isEnabled();

    const {data: result, isSuccess} = useQuery({
        enabled: isExp,
        queryFn: () =>
            apiConfig.instanceGusaBackend.request<UseOneStepType>({
                method: 'get',
                url: ENDPOINTS.CHECKOUT_ONE_STEP,
            }),
        queryKey: [ONE_STEP_AVAILABILITY_KEY],
        refetchOnWindowFocus: false,
        staleTime: Infinity, // Need to test when 1 step ready
    });

    return {
        isOneStepAvailable: Boolean(
            isSuccess && result?.data.selectedPaymentMethod && result?.data.selectedShippingMethod,
        ),
        ...result?.data,
    };
};
